import * as Yup from 'yup';
import React, { useState, useRef, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Typography,
  Avatar,
  Menu,
  MenuItem
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { makeStyles, styled } from '@mui/styles';
import { Box } from '@mui/system';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import FileBase64 from 'react-file-base64';
import { CircleSpinner } from 'react-spinners-kit';
import { ToastContainer, toast } from 'material-react-toastify';
import { useTranslation } from 'react-i18next';
import 'material-react-toastify/dist/ReactToastify.css';
import './Share.css';

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    position: 'relative',
    height: '100px'
  },
  header: {
    display: 'flex',
    position: 'absolute',
    width: 'calc(100%)',
    top: '-70px',
    alignItems: 'flex-end',
    '& > *': {
      margin: '24px 8px'
    }
  },
  spacer: {
    flexGrow: '1'
  },
  avatar: {
    border: `3px solid white`,
    width: 80,
    height: 80
  },
  actionGroup: {
    display: 'flex',
    width: '330px',
    justifyContent: 'space-between',
    marginRight: 0
  },
  summaryCards: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  summaryCard: {
    margin: 8,
    flexGrow: 1,
    padding: 24
  },
  tripCard: {
    margin: 8,
    padding: 16
  },
  input: {
    display: 'none'
  },
  large: {
    width: 100,
    height: 100
  },
  TopBar: {
    width: '100%',
    marginTop: '20px',
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  bottomBar: {
    width: '100%',
    marginTop: '20px',
    display: 'flex',
    alignItems: 'flex-end'
  },
  divider: {
    border: `1px solid lightgray`
  }
}));

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#f78181'
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#f78181'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'lightgray'
    },
    '&:hover fieldset': {
      borderColor: '#f78181'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#f78181'
    }
  }
});

export default function SharePostForm({ row, cancel }) {
  const [t, i18n] = useTranslation();
  const classes = useStyles();
  const [share, setShare] = useState('public');
  const [iconShare, setIconShare] = useState('mdi:earth');
  const [anchor, setAnchor] = useState(null);
  const [load, setLoad] = useState(false);

  const notifySuccess = (message) => {
    toast.success(message, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };
  const hiddenFileInput = React.useRef(null);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const isMenuOpen = Boolean(anchor);
  const openMenu = (event) => {
    setAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchor(null);
  };

  const userDetails = JSON.parse(localStorage.getItem('user'));
  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const formik = useFormik({
    initialValues: {
      pk_post: row.id,
      text: '',
      share_with: share
    },
    onSubmit: (values) => {
      setLoad(true);
      const token = localStorage.getItem('access');
      values.share_with = share;
      console.log('data', values);
      axios({
        method: 'post',
        url: `${API_ENDPOINT}/api/share-post-from-actuality/`,
        headers: { Authorization: `Bearer ${token}` },
        data: values
      })
        .then((response) => {
          setLoad(false);
          console.log('status: ', response.status);
          console.log('response: ', response.data);
          notifySuccess(response.data.Message);
          cancel();
        })
        .catch((err) => {
          setLoad(false);
          console.log('err', err.message);
        });
    },
    onReset: (values) => {
      values = '';
    }
  });

  const { errors, touched, values, isSubmitting, getFieldProps, setFieldValue } = formik;

  return (
    <FormikProvider value={formik}>
      {load && (
        <Box display="flex" justifyContent="center" sx={{ p: 3 }}>
          <CircleSpinner size={30} color="#ec8181" loading={load} />
        </Box>
      )}
      <Form autoComplete="off" style={{ width: '100%' }} noValidate onSubmit={formik.handleSubmit}>
        <ToastContainer />
        <Stack className={classes.TopBar}>
          <Avatar alt="name" src={`${API_ENDPOINT}${userDetails.photo}`} />
          <Box
            style={{
              alignItems: 'center',
              justifyContent: 'space-around'
            }}
          >
            <Typography variant="h8" style={{ marginRight: '20px', color: 'grey' }}>
              {t('Partageravec')}
            </Typography>
            <Button
              style={{
                maxWidth: '100px',
                marginRight: '20px',
                backgroundColor: '#ebf9f1',
                color: 'grey'
              }}
              variant="contained"
              startIcon={
                <Icon icon={iconShare} width={20} style={{ marginRight: '10px', color: 'grey' }} />
              }
              onClick={openMenu}
            >
              {share}
            </Button>
          </Box>
          <Menu
            id="basic-menu"
            anchorEl={anchor}
            open={isMenuOpen}
            onClose={closeMenu}
            keepMounted
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem
              onClick={() => {
                setShare('public');
                setIconShare('mdi:earth');
                closeMenu();
              }}
            >
              <Icon icon="mdi:earth" width={20} style={{ marginRight: '10px' }} />
              Public
            </MenuItem>
            <MenuItem
              onClick={() => {
                setShare('creche');
                setIconShare('mdi:home-group');
                closeMenu();
              }}
            >
              <Icon icon="mdi:home-group" width={20} style={{ marginRight: '10px' }} />
              Creche
            </MenuItem>
            <MenuItem
              onClick={() => {
                setShare('class');
                setIconShare('mdi:home');
                closeMenu();
              }}
            >
              <Icon icon="mdi:home" width={20} style={{ marginRight: '10px' }} />
              Class
            </MenuItem>
          </Menu>
        </Stack>
        <Stack spacing={3}>
          <CssTextField
            id="text"
            name="text"
            fullWidth
            autoComplete="text"
            multiline
            rows={2}
            type="text"
            label=""
            style={{ backgroundColor: '#F5F5F5' }}
            placeholder={t('message')}
            {...getFieldProps('text')}
          />
          <Stack
            spacing={3}
            direction="row"
            style={{
              backgroundColor: '#fff',
              alignItems: 'center'
            }}
          >
            <div
              style={{
                height: '150px',
                width: '100%',
                display: 'flex',
                padding: '5px',
                border: '1px solid lightgray'
              }}
            >
              {row.media !== '/media/None' &&
                row.media !== `${API_ENDPOINT}/media/null` &&
                row.media !== null && (
                  <img
                    alt="img"
                    style={{
                      height: '100%',
                      width: '50%',
                      objectFit: 'cover',
                      backgroundPosition: 'center'
                    }}
                    src={row.media}
                  />
                )}
              <div style={{ padding: '10px', width: '50%' }}>
                <Typography variant="body2" className="p">
                  {row.text}
                </Typography>
              </div>
            </div>
          </Stack>
        </Stack>
        <Stack className={classes.bottomBar}>
          <Box
            style={{
              alignItems: 'center',
              justifyContent: 'space-around'
            }}
          >
            <Button
              style={{
                maxWidth: '100px',
                marginRight: document.body.dir === 'ltr' && '20px',
                marginLeft: document.body.dir === 'rtl' && '20px',
                backgroundColor: 'grey'
              }}
              type="button"
              variant="contained"
              loading={isSubmitting}
              onClick={cancel}
            >
              {t('Annuler')}
            </Button>
            <Button
              style={{ maxWidth: '100px', backgroundColor: '#EC8B8B' }}
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              {t('publier')}
            </Button>
          </Box>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
